module.exports = __webpack_public_path__ + "img/icon_mall_arr_next.7e62219b.svg";